app.controller('accountingController', async function ($rootScope, $scope, $window, $routeParams, $filter, safeApply, accountingService) {

  /*
    Ledger row actions - both open a new tab.

    openInCRM reuses the current CRM URL and appends the row's user id:
    /{user_id}/{url_password}/{target_user_id}. crmController switches to the
    client panel when target_user_id is present, and clientController resolves
    the record from that param.

    openDashboard builds the brand-specific deep link. TPTC accounts live on a
    different host than PropertyTax.io ones, matching getDashboardLink() in
    clientController.
  */
  /*
    Copy a single cell value to the clipboard. navigator.clipboard needs a secure
    context, so keep the execCommand fallback for plain-http hosts - same shape
    as copyToClipboard in cadSyncTableController.
  */
  $scope.copyValue = function (value, label) {
    const text = value === null || value === undefined ? '' : String(value)
    if (!text.length) return

    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
    } else {
      const tempInput = document.createElement('input')
      tempInput.value = text
      document.body.appendChild(tempInput)
      tempInput.select()
      document.execCommand('copy')
      document.body.removeChild(tempInput)
    }
    toastr.success(text, `${label} Copied`, { timeOut: 2000 })
  }

  $scope.crmUrl = function (ledger) {
    if (!ledger || !ledger.user_id) return ''
    const userId = $routeParams.user_id
    const urlPassword = $routeParams.url_password
    if (!userId || !urlPassword) return ''
    return `/${userId}/${urlPassword}/${ledger.user_id}`
  }

  $scope.openInCRM = function (ledger) {
    const url = $scope.crmUrl(ledger)
    if (!url) return
    $window.open(url, '_blank')
  }

  $scope.dashboardUrl = function (ledger) {
    if (!ledger || !ledger.user_id || !ledger.token) return ''
    const host = ledger.business_source == 'TPTC'
      ? 'https://dashboard.texasptc.com'
      : 'https://dashboard.propertytax.io'
    return `${host}/${ledger.user_id}/${ledger.token}`
  }

  $scope.openDashboard = function (ledger) {
    const url = $scope.dashboardUrl(ledger)
    if (!url) {
      toastr.error('No dashboard token on this account', 'Cannot Open Dashboard')
      return
    }
    $window.open(url, '_blank')
  }

  /*
    Percentage of Total Due that an amount represents - used for the credit card,
    check and balance-due rows. Returns a 1dp string; 0 when Total Due is not yet
    loaded, so the template never renders NaN%.
  */
  $scope.pctOfTotal = function (amount) {
    const total = Number(($scope.receivables && $scope.receivables.total_due) || 0)
    const value = Number(amount || 0)
    if (!total) return '0.0'
    return ((value / total) * 100).toFixed(1)
  }

  /*
    Share of Total Due already collected, for the progress bar. Derived from the
    payment totals rather than from total_balance_due, which comes from the
    ledger and so tracks a slightly different population.
  */
  $scope.pctCollected = function () {
    const r = $scope.receivables
    const total = Number((r && r.total_due) || 0)
    if (!total) return '0.0'
    const summary = (r.payments && r.payments.summary) || {}
    const paid = Number((summary.cc && summary.cc.total) || 0) +
      Number((summary.ck && summary.ck.total) || 0)
    // Clamp: a period with prior-year payments can exceed the current total.
    return Math.min((paid / total) * 100, 100).toFixed(1)
  }

  /*
    Balance buckets, highest range first. Declared explicitly rather than
    iterating the object with ng-repeat, which depended on JS key order and left
    eight ng-if labels in the template.
  */
  const BUCKET_ORDER = [
    { key: 'over_5000', label: 'Over $5,000' },
    { key: 'between_2500_5000', label: '$2,500 - $5,000' },
    { key: 'between_1000_2500', label: '$1,000 - $2,500' },
    { key: 'between_500_1000', label: '$500 - $1,000' },
    { key: 'between_100_500', label: '$100 - $500' },
    { key: 'between_50_100', label: '$50 - $100' },
    { key: 'between_25_50', label: '$25 - $50' },
    { key: 'less_than_25', label: 'Less than $25' },
  ]

  $scope.bucketList = function () {
    const buckets = ($scope.receivables && $scope.receivables.balance_buckets) || {}
    return BUCKET_ORDER.map(b => {
      const row = buckets[b.key] || {}
      return {
        key: b.key,
        label: b.label,
        count: row.count || 0,
        sum: row.sum || 0,
        percentage_of_total: row.percentage_of_total || 0,
      }
    })
  }

  // Column footer totals, so the distribution can be reconciled at a glance.
  $scope.bucketTotals = function () {
    return $scope.bucketList().reduce(
      (acc, b) => ({ count: acc.count + b.count, sum: acc.sum + b.sum }),
      { count: 0, sum: 0 }
    )
  }

  init()
  async function init() {
    // No tax_year is passed: the query derives it from the billing_year app
    // config (@_taxYear), so any value sent here would be ignored. A literal
    // 2022 used to be passed, which read as if the screen were showing 2022.
    let getAccountingStatus_1Results = await accountingService.getAccountingStatus_1({})
    console.log('getAccountingStatus_1Results :>> ', getAccountingStatus_1Results);

    if (getAccountingStatus_1Results.data.success) {
      $scope.receivables = getAccountingStatus_1Results.data.data
      safeApply($scope)
    } else {
      toastr.error('Error getting records', 'Error')
    }
  }


})